const searchResultElem = document.querySelector('.search-result');
const headerSearchInput = document.querySelector('#searchTerm');

if (searchResultElem) {
  const filterRow = searchResultElem.querySelector('.search-result__filter-row');
  const resultRow = searchResultElem.querySelector('.search-result__row');
  const noResultElem = searchResultElem.querySelector('.search-result__no-result');
  const emptyTitle = searchResultElem.querySelector('.search-result__no-result-title');

  // ------
  // Search Result Page - Ajax
  // ------
  // GA4 search (vsak iskalni niz enkrat, ne ob menjavi zavihka)
  let lastTrackedSearchTerm = '';
  const trackSearch = (searchTerm) => {
    if (searchTerm && searchTerm !== lastTrackedSearchTerm) {
      lastTrackedSearchTerm = searchTerm;
      window.prowDL.pushEvent({ event: 'search', search_term: searchTerm });
    }
  };
  // Prvo nalaganje: rezultati za ?searchTerm= so izrisani na strežniku
  trackSearch((new URLSearchParams(window.location.search).get('searchTerm') || '').trim());

  const axiosGetSearchResult = async (searchTerm, searchCpt) => {
    trackSearch(searchTerm);
    headerSearchInput.setAttribute('value', searchTerm);

    const formDataInput = {
      action: 'getSearchResultPosts',
      searchTerm,
      searchCpt,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);

      const htmlFilter = data.data?.html_filter || '';
      const htmlList = data.data?.html_list || '';

      if (!searchCpt || searchCpt === 'all') {
        filterRow.innerHTML = htmlFilter;
      }
      resultRow.innerHTML = htmlList;

      if (htmlList || htmlFilter) {
        noResultElem?.classList.add('hide');
      } else {
        if (!emptyTitle) return;

        const strong = emptyTitle.querySelector('strong');

        if (searchTerm) {
          if (strong) {
            strong.textContent = `“${searchTerm}”`;
          } else {
            emptyTitle.innerHTML += ` <strong>“${searchTerm}”</strong>`;
          }
        } else {
          strong?.remove();
        }

        noResultElem?.classList.remove('hide');
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['searchTerm', 'searchCpt']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${encodeURIComponent(formDataInput[item])}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error(err);
    }
  };

  // ------
  // Toggle filter type buttons
  // ------
  const getActiveFilterValue = () => {
    const active = searchResultElem.querySelector('.search-result__filter-btn.is-active');
    return active?.dataset.filter || '';
  };

  const getSearchTerm = () => headerSearchInput?.value.trim() || '';

  const triggerSearch = () => {
    axiosGetSearchResult(getSearchTerm(), getActiveFilterValue());
  };

  // ------
  // Search Submit
  // ------
  attachEvent('.header-search__submit', 'click', (ev) => {
    ev.preventDefault();

    document.body.classList.remove('is-open-search', 'body-scroll-locked', 'show-bottom-bar');

    document.querySelector('.header-search__wrapper')?.classList.add('hide');

    // Activate "all" filter
    searchResultElem
      .querySelectorAll('.search-result__filter-btn')
      .forEach((btn) => btn.classList.toggle('is-active', btn.dataset.filter === 'all'));

    triggerSearch();
  });

  // ------
  // Search Filter
  // ------
  attachEvent('.search-result__filter-btn', 'click', (ev) => {
    const button = ev.target.closest('.search-result__filter-btn');
    if (!button) {
      return;
    }

    searchResultElem.querySelectorAll('.search-result__filter-btn').forEach((btn) => btn.classList.remove('is-active'));

    button.classList.add('is-active');

    triggerSearch();
  });
}
